import type { FormItem } from 'form/types';

import { radioOptions } from './shared';

const step: FormItem[] = [
  {
    type: 'checkbox',
    id: 'wear-mask',
    label: 'will wear face masks over the nose and mouth'
  },
  {
    type: 'checkbox',
    id: 'vaccinated',
    label: 'has had at least one dose of COVID-19 vaccine (or have proof of medical exception)'
  },
  {
    type: 'checkbox',
    id: 'checkin',
    label: 'must check in via QR code before entering the site'
  },
  {
    type: 'checkbox',
    id: 'social-distance',
    label:
      'will keep at least 1.5 metres apart from other workers and maintain at least 4 square meters of space per person.'
  },
  {
    type: 'checkbox',
    id: 'report-cases',
    label: 'will report suspected or confirmed COVID-19 cases to the site manager and COVID Marshal'
  },
  {
    type: 'heading',
    id: 'risk-mitigation',
    label: 'I confirm that my worksite will have the following risk mitigation measures in place:'
  },
  {
    type: 'checkbox',
    id: 'marshal',
    label: 'I have a trained COVID Marshal monitoring the site'
  },
  {
    type: 'checkbox',
    id: 'signage',
    label: 'I have prominent signage about density limits, QR codes and face mask requirements'
  },
  {
    type: 'checkbox',
    id: 'bubble',
    label: 'I will ensure workers consistently work in the same group of workers where possible'
  },
  {
    type: 'checkbox',
    id: 'vaccination-evidence',
    label:
      'I have seen evidence that all workers (including employees, contractors and volunteers on site) have received their first dose of a COVID-19 vaccine.'
  },
  {
    type: 'checkbox',
    id: 'records',
    label:
      'I will keep an up-to-date record of the vaccination status of all workers (including volunteers, employees or contractors) on the site'
  },
  {
    type: 'checkbox',
    id: 'crib-cleaning',
    label:
      'Lunchrooms, crib rooms or indoor rest areas – if we have them – all meet the rules for cleaning, density and ventilation'
  },
  {
    type: 'checkbox',
    id: 'covidsafe-plan',
    label: 'I have a complete and current COVIDSafe plan, in practice now'
  },
  {
    type: 'spacer',
    id: 'sp-123',
    label: ''
  },
  {
    type: 'radio',
    id: 'siteType',
    label: 'What kind of a construction site are you running?',
    options: Object.entries(radioOptions).map(([value, label]) => ({
      label,
      value
    }))
  }
];

export default step;
